export const KapanData = {
  tabs: [
    {
      label: 'All Kapan Data',
      id: 1,
    },
  ],
};